import { styled } from '@mui/system';

import { AgColor } from '../../../stories/Styles/AgColor';

export const Container = styled('div')`
  padding: 24px 16px;
`;

export const MDContainer = styled('section')`
  box-sizing: border-box;
  padding: 30px;
  border: 1px solid ${AgColor.grey4};
  border-radius: 8px;
  margin-bottom: 20px;
  
  overflow-y: auto;
  max-height: calc(100vh - 450px);

  ::-webkit-scrollbar {
    width: 6px;
  };

  ::-webkit-scrollbar-thumb {
    background: #e4e2e4;
    border-radius: 6px;
  }
`;